<div *ngIf="isLoading">Loading Marital Status List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="maritalStatus" [(ngModel)]="model.maritalStatus" [required]="required">
  <option *ngFor="let singleMaritalStatus of maritalStatuses" [ngValue]="singleMaritalStatus">{{ singleMaritalStatus.name }}</option>
</select>
